
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","stroke":"#FF6F4F","stroke-width":"2","stroke-miterlimit":"10"}},[_c('g',{attrs:{"clip-path":"url(#clip1)"}},[_c('path',{attrs:{"d":"M10 18.35V11.2h20v7.15"}}),_c('path',{attrs:{"d":"M38 25.5v-7.26H2v14.68h19M2 32.92v6.35M38 34v5.27"}}),_c('path',{attrs:{"d":"M35.51 18.26V6.46a4.74 4.74 0 00-4.73-4.73H9.22a4.74 4.74 0 00-4.73 4.73v11.8"}})]),_c('path',{attrs:{"d":"M29.807 38.793a9.193 9.193 0 100-18.386 9.193 9.193 0 000 18.386zM26.5 33.19l6.7-6.69M33.2 33.19l-6.7-6.69"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})]),_c('clipPath',{attrs:{"id":"clip1"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    